import companyFrPages from './companyPages';
import cpnFrLang from './component';
import menuFrLang from './menu';
import pageFrLang from './pages';
import serverFrMessages from './serverMessages';
import exportFrColumns from './exportColumns';

const frLang = {
  ...serverFrMessages,
  ...exportFrColumns,
  ...pageFrLang,
  ...cpnFrLang,
  ...menuFrLang,
  ...companyFrPages,
  //base table
  'zTable.edit': 'Modifier',
  'zTable.copy': 'Copier',
  'zTable.delete': 'Supprimer',
  'zTable.actions': 'Actions',
  'zTable.search': 'Rechercher',
  'zTable.reset': 'Réinitialiser',
  'zTable.records': 'Nombre de recherches: ',
  'zTable.pageSize': 'Résultats affichés ',
  // roles
  UserName: `Nom d'utilisateur`,
  UserNameOrEmail: 'E-mail/ID de compte',
  User: 'Utilisateur',
  EmailConfirmed: 'E-mail confirmé',
  LockoutEnabled: 'Verrouillage activé',
  RoleUpdateTile: 'Mise à jour du rôle',
  RegisterUser: `Enregistrer l'utilisateur`,
  UpdateUser: `Mettre à jour l'utilisateur`,
  CreateNewRole: 'Créer un nouveau rôle',
  UpdateNewRole: 'Mettre à jour le nouveau rôle',
  Password: 'Mot de passe',
  ConfirmPassword: 'Confirmez le mot de passe',
  NameRole: 'Nom',
  LoginButton: 'Connexion',
  ForgotPassword: 'Mot de passe oublié',
  // base
  createNew: 'Créer un nouveau',
  save: 'Sauvegarder',
  cancel: 'Annuler',
  VALIDATE_REQUIRED: 'Veuillez remplir ce champ',
  Change_Password: 'Changer le mot de passe',
  Change_Layout: 'Changer la disposition',
  Profile: 'Profil',
  SignOut: 'Déconnexion',
  Close: 'Fermer',
  Export: 'Exporter',
  Downloading: 'Téléchargement',
  'base.CreatedOn': 'Créé le',
  'base.CreatedBy': 'Créé par',
  'base.UpdatedOn': 'Mise à jour le',
  'base.UpdatedBy': 'Mis à jour par',
  'base.PhoneNumber': 'Numéro de téléphone',
  'base.Address': 'Adresse',
  'base.Country': 'Pays',
  'base.Region': 'Région',
  'base.City': 'Ville',
  'base.Image': 'Image',
  'base.IpAddress': 'Adresse IP',
  'base.Port': 'Port',
  'base.UserName': `Nom d'utilisateur`,
  'base.Password': 'Mot de passe',
  'base.Method': 'Méthode',
  'base.Interface': 'Interface',
  'base.SSID': 'SSID',
  'base.SystemProvider': 'Fournisseur système',
  'base.SystemVersion': 'Version système',
  'base.Encryption': 'Cryptage',
  'base.DecryptionKey': 'Clé de déchiffrement',
  'base.EncryptionKey': 'Clé de cryptage',
  'base.Provider': 'Fournisseur',
  'base.Provider2': 'Fournisseur 2',
  'base.PayId': 'PayId',
  'base.PayId2': 'PayId2',
  'base.Controller': 'Contrôleur',
  'base.DataType': 'Type de données',
  'base.OwnPrivateKey': 'Propre clé privée',
  'base.OrangePublicKey': 'Clé publique orange',
  'base.OperatorId': 'OperatorId',
  'base.AppId': 'AppId',
  'base.Active': 'Actif',
  'base.SetActive': 'Activer',
  'base.SetInActive': 'Définir comme inactif',
  'base.UpdateSucessMessage': 'Mise à jour réussie',
  'base.IsVerified': 'Est vérifié',
  'base.Email': 'E-mail',
  'base.FullName': 'Nom complet',
  'base.DateOfBirth': 'Date de naissance',
  'base.Married': 'Marié',
  'base.Gender': 'Sexe',
  'base.Company': 'Compagnie',
  'base.Enabled': 'Activé',
  'base.Description': 'La description',
  'base.From': 'De',
  'base.To': 'To',
  'base.Value': 'Valeur',
  'base.IsActive': `C'est actif`,
  'base.Code': 'Code',
  'base.IsStandard': 'Est standard',
  'base.FirstName': 'Prénom',
  'base.LastName': 'Nom de famille',
  'base.IPAddress': 'Adresse IP',
  'base.Download': 'Télécharger',
  'base.Export': 'Exporter',
  'base.Status': 'Statut',
  'base.MarriedStatus': 'Statut de personne mariée',
  // Lot P4 : limites d'âge des tarifs.
  tariffAge_Column: 'Âges',
  tariffAge_MinAge: 'Âge minimum (ans)',
  tariffAge_MaxAge: 'Âge maximum (ans)',
  tariffAge_NoLimit: 'Pas de limite',
  tariffAge_Help: "Âge du passager le jour du départ, bornes comprises (2 à 11 : de 2 ans révolus jusqu'à la veille des 12 ans). Vide : pas de limite. Avec une limite, la date de naissance est obligatoire à la vente et à la modification.",
  tariffAge_None: '—',
  tariffAge_From: 'dès {{min}} ans',
  tariffAge_UpTo: "jusqu'à {{max}} ans",
  tariffAge_Between: 'de {{min}} à {{max}} ans',
  TariffAgeLimitsInvalid: "Limites d'âge invalides : entre 0 et 120 ans, minimum au plus égal au maximum.",
  passengerType_Title: 'Type de passager',
  passengerType_Adult: 'Adulte',
  passengerType_Child: 'Enfant',
  passengerType_Infant: 'Bébé',
  passengerType_Help: "Adulte, enfant ou bébé. Un enfant ou un bébé voyage toujours avec un adulte de la même réservation. Étudiant, militaire, senior… sont des adultes (avec, si besoin, une limite d'âge sur le tarif de la compagnie).",
  passengerType_ReadOnly: 'Défini dans le catalogue global des tarifs (super administrateur).',
  tariffAgeIssues_ChildMustTravelWithAdult: 'Enfant sans adulte',
  controlReviews_CategoryManual: "Saisies du numéro hors ligne",
  controlReviews_CategoryOnlineManual: "Saisies du numéro en ligne",
  controlReviews_flag_OnlineManualEntry: "Saisie du numéro en ligne",
  baggageReconciliation_WithoutTicket: "Bagages sans billet",
  baggageReconciliation_ToReview: "À revoir",
  baggageReconciliation_TotalHeld: "Total détenu",
  controlReviews_Title: "Contrôles et ventes hors ligne à revoir",
  controlReviews_Explanation: "Actions faites sans réseau, gardées par le serveur mais signalées : écarts de prix, montées sans contrôle, heures incohérentes, saisies du numéro. Marquer comme revu ne change ni le billet ni la caisse.",
  controlReviews_GapsByAgent: "Écarts de prix par chauffeur",
  controlReviews_NoGaps: "Aucun écart de prix à revoir.",
  controlReviews_None: "Aucun signalement à revoir.",
  controlReviews_IncludeReviewed: "Afficher aussi les signalements déjà revus",
  controlReviews_CategoryAll: "Tous les signalements",
  controlReviews_CategoryPriceGap: "Écarts de prix",
  controlReviews_CategoryBoarding: "Montées hors ligne sans contrôle",
  controlReviews_CategoryTime: "Heures incohérentes",
  controlReviews_CategoryOther: "Autres",
  controlReviews_Agent: "Agent",
  controlReviews_Count: "Nombre",
  controlReviews_Declared: "Montant déclaré",
  controlReviews_Expected: "Montant au tarif",
  controlReviews_Gap: "Écart",
  controlReviews_SeeDetails: "Voir le détail",
  controlReviews_RecordedAt: "Date",
  controlReviews_Terminal: "Terminal",
  controlReviews_Ticket: "Billet",
  controlReviews_Kind: "Action",
  controlReviews_KindCheckIn: "Contrôle",
  controlReviews_KindBoarding: "Embarquement",
  controlReviews_KindSale: "Vente à bord",
  controlReviews_Flags: "Signalements",
  controlReviews_Result: "Résultat",
  controlReviews_Kept: "Gardé",
  controlReviews_Refused: "Refusé",
  controlReviews_Review: "Revue",
  controlReviews_ReviewedBy: "Revu par {{name}} le {{date}}",
  controlReviews_MarkReviewed: "Marquer comme revu",
  controlReviews_ConfirmReview: "Marquer ce signalement comme revu ?",
  controlReviews_Reviewed: "Signalement marqué comme revu",
  controlReviews_flag_PriceGap: "Écart de prix",
  controlReviews_flag_ManualEntry: "Saisie du numéro",
  controlReviews_flag_NoKnownCheckIn: "Montée sans contrôle connu",
  controlReviews_flag_UnusedAtSync: "Reçu après « non utilisé »",
  controlReviews_flag_DoubleUse: "Double usage",
  controlReviews_flag_AfterBoardingClose: "Après la fermeture",
  controlReviews_flag_RevokedAfterControl: "Annulé après le contrôle",
  controlReviews_flag_TerminalRevokedAfterControl: "Terminal révoqué après le contrôle",
  controlReviews_flag_UnattestedTerminal: "Terminal non attesté",
  controlReviews_flag_UntrustedClock: "Horloge non fiable",
  controlReviews_flag_CounterTimeMismatch: "Heure contraire au compteur",
  controlReviews_flag_ClockFarFromServer: "Heure éloignée du serveur",
  controlReviews_flag_ModifiedSincePrint: "Billet modifié depuis le QR",
  controlReviews_flag_BaggageAmountGap: "Écart sur les bagages",
  controlReviews_flag_BaggageOverLimit: "Bagages au-delà du maximum",
  controlReviews_flag_BaggageNotRecorded: "Bagages non enregistrés",
  controlReviews_flag_TerminalRetiredBeforeSync: "Terminal retiré avant la réception",
  controlReviews_CategoryTerminal: "Terminal retiré ou révoqué",
  controlReviews_flag_BaggagePaymentAlreadyRecorded: "Bagages déjà enregistrés en ligne : non comptés une seconde fois",
  tariffAgeIssues_Title: 'Ventes hors ligne à revoir : âge et accompagnement',
  tariffAgeIssues_Explanation: "Ventes synchronisées depuis une tablette ou faites à bord hors ligne, gardées car déjà payées, dont le tarif ne correspond pas à l'âge du passager le jour du départ (ou sans date de naissance pour un tarif limité), ou dont un enfant voyage sans adulte de la réservation. Pour corriger un billet, faites une modification de billet (changement de tarif) depuis l'app caissier, puis marquez la vente comme revue.",
  tariffAgeIssues_IncludeReviewed: 'Afficher aussi les ventes déjà revues',
  tariffAgeIssues_None: 'Aucune vente incohérente à revoir.',
  tariffAgeIssues_Ticket: 'Billet',
  tariffAgeIssues_Source: 'Origine',
  tariffAgeIssues_SourceTablet: 'Tablette (hors ligne)',
  tariffAgeIssues_SourceOnBoard: 'Vente à bord (hors ligne)',
  tariffAgeIssues_Passenger: 'Passager',
  tariffAgeIssues_BirthDate: 'Date de naissance',
  tariffAgeIssues_Tariff: 'Tarif',
  tariffAgeIssues_Departure: 'Départ',
  tariffAgeIssues_Issue: 'Incohérence',
  tariffAgeIssues_TariffAgeOutOfRange: 'Âge hors du tarif',
  tariffAgeIssues_TariffBirthDateRequired: 'Date de naissance manquante',
  tariffAgeIssues_SoldOn: 'Vendu le',
  tariffAgeIssues_Review: 'Revue',
  tariffAgeIssues_MarkReviewed: 'Marquer revue',
  tariffAgeIssues_ConfirmReview: 'Marquer cette vente comme revue ? Elle sortira de la liste (visible dans les ventes revues).',
  tariffAgeIssues_Reviewed: 'Vente marquée comme revue.',
  tariffAgeIssues_ReviewedBy: 'Revue par {{name}} le {{date}}',
  registerReconciliation_CreditNotesIssued: 'Avoirs émis (hors espèces)',
  registerReconciliation_CreditNotesIssuedValue: '{{count}} avoir(s) · {{amount}}',
  registerReconciliation_CreditNotesUsed: 'Avoirs utilisés aux ventes (hors espèces)',
  registerReconciliation_CreditNotesUsedValue: '{{count}} vente(s) · {{amount}} ; rendus aux avoirs : {{returned}}',
  creditNotes_Title: 'Avoirs',
  creditNotes_Explanation: "Avoirs de la compagnie : émis par une modification ou une annulation de billet, utilisés aux ventes du guichet (en tout ou en partie, jamais en espèces). Un avoir expiré n'est plus utilisable. Lecture seule.",
  creditNotes_AllStatuses: 'Tous les avoirs',
  creditNotes_Status_active: 'Actif',
  creditNotes_Status_partial: 'En partie utilisé',
  creditNotes_Status_used: 'Soldé',
  creditNotes_Status_expired: 'Expiré',
  creditNotes_Status_cancelled: 'Annulé',
  creditNotes_Number: 'Numéro',
  creditNotes_Holder: 'Titulaire',
  creditNotes_Phone: 'Téléphone',
  creditNotes_Amount: 'Montant',
  creditNotes_Balance: 'Solde',
  creditNotes_BalanceAfter: 'Solde après',
  creditNotes_IssuedOn: 'Émis le',
  creditNotes_IssuedBy: 'Émis par',
  creditNotes_ExpiresOn: "Valable jusqu'au",
  creditNotes_Status: 'Statut',
  creditNotes_Uses: 'Utilisations',
  creditNotes_Detail: 'Détail',
  creditNotes_DetailTitle: 'Avoir {{number}}',
  creditNotes_Search: 'Rechercher',
  creditNotes_Totals: '{{count}} avoir(s) · émis {{amount}} · solde restant {{balance}}',
  creditNotes_None: 'Aucun avoir.',
  creditNotes_NoMovement: 'Aucune utilisation.',
  creditNotes_IssuedFor: 'Émis pour le(s) billet(s)',
  creditNotes_Source: "Avoir d'origine (expiré)",
  creditNotes_MovementOn: 'Date',
  creditNotes_MovementKind: 'Mouvement',
  creditNotes_Movement_use: 'Utilisé à une vente',
  creditNotes_Movement_recredit: 'Rendu (annulation ou modification)',
  creditNotes_Booking: 'Réservation',
  creditNotes_Ticket: 'Billet',
  creditNotes_By: 'Par',
  registerReconciliation_CreditNotesHelp: "Rendus de modifications de billets en avoir depuis le dernier rapprochement : aucune sortie d'espèces, non compris dans les totaux encaissés.",
  // Lot P3 : PIN de chef de gare, réimpressions.
  supervisorPin_Menu: "PIN de chef de gare",
  supervisorPin_Title: "PIN personnel de chef de gare",
  supervisorPin_Explanation: "Ce PIN de 6 chiffres vous est propre. Vous le saisissez sur le terminal du caissier, après avoir choisi votre nom, pour valider la 3e réimpression d'un billet (et les opérations sensibles à venir). Ne le communiquez à personne.",
  supervisorPin_NewPin: "Nouveau PIN (6 chiffres)",
  supervisorPin_ConfirmPin: "Confirmer le PIN",
  supervisorPin_SixDigits: "Le PIN compte exactement 6 chiffres.",
  supervisorPin_NotMatch: "Les deux PIN ne correspondent pas.",
  supervisorPin_Saved: "PIN de chef de gare enregistré.",
  supervisorPin_Blocked: "Votre PIN est bloqué après 5 erreurs : choisissez-en un nouveau pour le débloquer.",
  supervisorPin_AlreadySet: "Vous avez déjà un PIN : en choisir un nouveau remplace l’ancien.",
  ticketReprints_Title: "Réimpressions du billet",
  ticketReprints_Column: "Réimpressions",
  ticketReprints_None: "Aucune réimpression.",
  ticketReprints_Date: "Date",
  ticketReprints_Cashier: "Caissier",
  ticketReprints_Terminal: 'Terminal',
  ticketReprints_Register: "Caisse",
  ticketReprints_ApprovedBy: "Chef de gare",
  ticketModifications_Title: "Modifications du billet",
  ticketModifications_None: "Aucune modification.",
  ticketModifications_Date: "Date",
  ticketModifications_Tickets: "Billet remplacé → nouveau",
  ticketModifications_Changes: "Changements",
  ticketModifications_Difference: "Différence",
  ticketModifications_Fee: "Frais",
  ticketModifications_FeeWaived: "Offerts",
  ticketModifications_CreditNote: "Avoir",
  ticketModifications_ModifiedBy: "Modifié par",
  ticketModifications_Register: "Caisse",
  ticketModifications_ApprovedBy: "Approuvé par",
  ticketModifications_KindDeparture: "Départ",
  ticketModifications_KindSeat: "Siège",
  ticketModifications_KindTariff: "Tarif",
  ticketModifications_KindName: "Nom corrigé",
  ticketModifications_KindTransfer: "Transfert",
  ticketModifications_KindHolder: "Coordonnées",
  ticketModifications_KindDestination: "Destination",
  seller_Register: "Caisse",
  seller_Cashier: "Caissier",
  companySettingsPage_PrintLanguage: "Langue d'impression",
  companySettingsPage_PrintLanguageHint: "Langue des billets et reçus imprimés par l'app caissier, quelle que soit la langue de son écran. Prise en compte à la prochaine connexion du caissier.",
  resetPasswordPage_TitleInvitation: "Définir mon mot de passe",
  resetPasswordPage_InvitationHint: "Choisissez le mot de passe de votre compte Prisme. Ce lien ne sert qu'une fois.",
  salesReport_Modifications: "Modifications de billets",
  salesReport_NoModification: "Aucune modification sur la période.",
  salesReport_Date: "Date",
  salesReport_Booking: "Réservation",
  salesReport_Tickets: "Billet remplacé → nouveau",
  salesReport_Station: "Gare",
  salesReport_Settlement: "Règlement",
  salesReport_Difference: "Différence",
  salesReport_TotalSales: "Ventes",
  salesReport_TotalModifications: "Modifications",
  salesReport_TotalOutstanding: "Reste dû",
  salesReport_Settlement1: "Aucun",
  salesReport_Settlement2: "Encaissé",
  salesReport_Settlement3: "Rendu en espèces",
  salesReport_Settlement4: "Rendu en avoir",
  salesReport_Settlement5: "Rendu au portefeuille",
  salesReport_Settlement6: "Rendu à l'avoir payeur",
  CurrentPasswordInvalid: "Mot de passe actuel incorrect.",
  SupervisorPinMalformed: "Le PIN compte exactement 6 chiffres.",
  SupervisorPinNotStationSupervisor: "Vous n'êtes administrateur ni superviseur d'aucune gare : pas de PIN de chef de gare.",
  // Étape 5 (2026-11-02) : clés qui n'existaient qu'en anglais.
  'base.PhoneCode': 'Indicatif',
  'base.Name': 'Nom',
  'base.PassportNo': 'N° de passeport',
  'base.Nationality': 'Nationalité',
  'base.DateOfIssue': 'Date de délivrance',
  'base.DateOfExpiry': 'Date d\'expiration',
  'base.CountryCode': 'Code pays',
  'base.PlaceOfBirth': 'Lieu de naissance',
  'base.Date': 'Date',
  'base.Amount': 'Montant',
  'base.CustomerName': 'Nom du client',
  'base.Note': 'Note',
  'base.Cashier': 'Caissier',
  'base.Comment': 'Commentaire',
  'base.Close': 'Fermer',
  'base.Source': 'Origine',
  'base.Destination': 'Destination',
  // Étape 5 (2026-11-02) : clés utilisées par le code et absentes des deux langues.
  cancellationPolicyPage_DuplicateDaysError: 'Ce nombre de jours existe déjà',
  'Additional Services': 'Services supplémentaires',
  Address: 'Adresse',
  'Are you sure want to delete this item?': 'Supprimer cet élément ?',
  Cancel: 'Annuler',
  'Carrier Code': 'Code transporteur',
  'Check All': 'Tout sélectionner',
  'Columns Config': 'Colonnes',
  'Company Name': 'Nom de la compagnie',
  'Confirm password': 'Confirmer le mot de passe',
  Contains: 'Contient',
  Delete: 'Supprimer',
  Download: 'Télécharger',
  'Email templates': 'Modèles d\'e-mail',
  'Ends with': 'Se termine par',
  Error: 'Erreur',
  Import: 'Importer',
  InvalidLoginAttempt: 'L\'opération a échoué. Réessayez.',
  Latitude: 'Latitude',
  LoginSessionExpiredContent: 'Votre session a expiré. Reconnectez-vous.',
  LoginSessionExpiredTitle: 'Session expirée',
  Longitude: 'Longitude',
  Name: 'Nom',
  'Passenger Info': 'Informations du passager',
  PasswordValidation: 'Saisissez votre mot de passe',
  'Pdf templates': 'Modèles PDF',
  'Profile image': 'Photo de profil',
  Reset: 'Réinitialiser',
  Save: 'Enregistrer',
  'Select date': 'Choisir une date',
  'Starts with': 'Commence par',
  UserNameValidation: 'Saisissez votre identifiant ou votre e-mail',
  Value: 'Valeur',
  close: 'Fermer',
  emailTemplate_Attachment_CultureCode: 'Langue',
  // Étape 5 (2026-11-02) : textes écrits en dur dans les écrans, le texte anglais d'origine sert de clé.
  '(Kms)': '(km)',
  ALL: 'Tous',
  'Arrival trips': 'Arrivées',
  Available: 'Disponible',
  'Baggage Ref': 'Réf. bagage',
  'Baggage type': 'Type de bagage',
  'Base Trip': 'Trajet de base',
  Basic: 'De base',
  Before: 'Avant',
  Bio: 'Présentation',
  'Booking Ref': 'Réf. réservation',
  'Bookings Amount': 'Montant des réservations',
  'Brand Country': 'Pays de la marque',
  'Brand Name': 'Nom de la marque',
  'Brand Symbol': 'Logo de la marque',
  Bus: 'Car',
  'Bus No.': 'N° du car',
  'Can not connect to printer': 'Connexion à l\'imprimante impossible',
  'Cancelled Amount': 'Montant annulé',
  'Cashier Booking': 'Réservations au guichet',
  'Character and number (ex: A01, A02)': 'Lettre et numéro (ex. : A01, A02)',
  City: 'Ville',
  'Click Action': 'Action au clic',
  Companies: 'Compagnies',
  'Conflict ticket': 'Billet en conflit',
  Country: 'Pays',
  'Created on': 'Créé le',
  'Date Departure': 'Date de départ',
  'Departure Date': 'Date de départ',
  'Departure time': 'Heure de départ',
  'Departure trips': 'Départs',
  'Discount Amount': 'Montant des remises',
  'Do you want to cancel other trip?': 'Annuler l\'autre trajet ?',
  'Document number': 'Numéro du document',
  'End Date': 'Date de fin',
  English: 'English',
  'Expense Detail': 'Détail des dépenses',
  'External Url': 'Adresse externe',
  France: 'Français',
  'Free booked': 'Réservés gratuitement',
  From: 'De',
  'From date': 'Du',
  Hours: 'Heures',
  'Identity type': 'Type de pièce d\'identité',
  'Image URL': 'Adresse de l\'image',
  Info: 'Infos',
  'Is Active': 'Actif',
  Map: 'Carte',
  Mins: 'min',
  Minutes: 'Minutes',
  'Next 7 days': '7 prochains jours',
  'No. of Baggage': 'Nombre de bagages',
  'No. of Booking': 'Nombre de réservations',
  'No. of Bookings': 'Nombre de réservations',
  'No. of Bus': 'Nombre de cars',
  'No. of Passenger': 'Nombre de passagers',
  'No. of Passengers': 'Nombre de passagers',
  'No. of Shipment': 'Nombre de colis',
  'No. of Ticket': 'Nombre de billets',
  'No. of Trip': 'Nombre de trajets',
  Note: 'Remarque',
  'Number and  character  (ex: 01A, 20A)': 'Numéro et lettre (ex. : 01A, 20A)',
  'Number and ticket class   (ex: 01E, 40B)': 'Numéro et classe (ex. : 01E, 40B)',
  'Occupancy Rate': 'Taux de remplissage',
  'Online Booking': 'Réservations en ligne',
  'Only number (ex: 01, 02)': 'Numéro seul (ex. : 01, 02)',
  Optional: 'Optionnel',
  Order: 'Ordre',
  'OutStanding Amount': 'Montant restant',
  'Over The Counters': 'Au guichet',
  'Passenger name and phone number': 'Nom et téléphone du passager',
  'Payment Details': 'Détail du paiement',
  Region: 'Région',
  Report: 'Rapport',
  Revenue: 'Recettes',
  Route: 'Itinéraire',
  'Sales Report Ticket Details': 'Détail des billets vendus',
  'Schedule Passengers': 'Passagers réservés',
  Screen: 'Écran',
  'Seat Color': 'Couleur du siège',
  'Select export method': 'Mode d\'export',
  'Select other seat': 'Choisir un autre siège',
  'Select route': 'Choisir un itinéraire',
  'Sell On The Go Passengers': 'Passagers vendus en route',
  'Sell station': 'Gare de vente',
  'Selling Assignment': 'Affectation de vente',
  'Send report to email successfully!': 'Rapport envoyé par e-mail.',
  'Send verifycation code successfull!': 'Code de vérification envoyé.',
  'Shipment, Tickets & Baggage Details': 'Colis, billets et bagages',
  'Shipments Handled': 'Colis traités',
  'Some seats do not have ticket class or seat name!': 'Des sièges n\'ont ni classe ni nom',
  'Some seats do not have ticket class or seat name. Do you want to save this data?': 'Des sièges n\'ont ni classe ni nom. Enregistrer quand même ?',
  'Start Date': 'Date de début',
  'Start date': 'Date de début',
  'Starting character': 'Lettre de départ',
  'Starting number': 'Numéro de départ',
  'Ticket Sold': 'Billets vendus',
  'Ticket amount': 'Montant des billets',
  'Ticket class and number (ex: E01, B02)': 'Classe et numéro (ex. : E01, B02)',
  'Ticket type': 'Type de billet',
  Title: 'Titre',
  'To Date': 'Au',
  'Toilet left': 'Toilettes (gauche)',
  'Toilet right': 'Toilettes (droite)',
  'Total Seats': 'Nombre de sièges',
  'Trip Name': 'Trajet',
  'Trip map': 'Carte du trajet',
  'Trip name': 'Trajet',
  Type: 'Type',
  'Update Success!': 'Mise à jour effectuée.',
  'Update success': 'Mise à jour effectuée.',
  'Upload video': 'Ajouter une vidéo',
  'Video Thumbnail Url': 'Adresse de la miniature',
  'Video Url': 'Adresse de la vidéo',
  Year: 'Année',
  Yes: 'Oui',
  hours: 'heures',
  tripCompanyId: 'Compagnie du trajet',
  'Trips Report': 'Rapport des trajets',
  'Trip Details Report': 'Détail des trajets',
  'Trip Income Report': 'Recettes par trajet',
  'Sale With Group Report': 'Ventes par groupe',
  'Sales Report': 'Rapport des ventes',
  'Trip Status': 'État des trajets',
  'Un Earned Revenue Report': 'Produits constatés d\'avance',
  'Company Roles': 'Rôles de la compagnie',
  'Manage templates': 'Modèles',
  'Passenger App Advertising': 'Publicités de l\'app passagers',
  'Sell on the go bookings': 'Ventes en route',
  Distance: 'Distance',
  Date: 'Date',
  External: 'Externe',
  WithDraw: 'Retrait',
  Ready: 'Prête',
  Closed: 'Fermée',
  Booked: 'Réservé',
  Selected: 'Sélectionné',
  Blocked: 'Bloqué',
  Partner: 'Partenaire',
  Online: 'En ligne',
  Tickets: 'Billets',
  Shipments: 'Colis',
  Expenses: 'Dépenses',
  Bagages: 'Bagages',
  Adult: 'Adulte',
  Child: 'Enfant',
  Infant: 'Bébé',
  Expense: 'Dépense',
  Seat: 'Siège',
  Door: 'Porte',
  Fridge: 'Réfrigérateur',
  Submit: 'Enregistrer',
  Confirm: 'Confirmer',
  Source: 'Origine',
  Destination: 'Destination',
  Station: 'Gare',
  Amount: 'Montant',
  Trip: 'Trajet',
  Recurrence: 'Récurrence',
  // Étape 5 (2026-11-02) : valeurs des listes déroulantes (constants.ts, __getSelectOptions), clé « enum.<Valeur> ».
  'enum.Oui': 'Oui',
  'enum.Non': 'Non',
  'enum.None': 'Aucune',
  'enum.LinkToTripDetail': 'Détail du trajet',
  'enum.ExternalUrl': 'Lien externe',
  'enum.Image': 'Image',
  'enum.Video': 'Vidéo',
  'enum.BeforeLogin': 'Avant connexion',
  'enum.Home': 'Accueil',
  'enum.Slider': 'Carrousel',
  'enum.StaticPanel': 'Bandeau fixe',
  'enum.Payment': 'Paiement',
  'enum.CashInCashOut': 'Dépôt et retrait',
  'enum.Sms': 'SMS',
  'enum.Email': 'E-mail',
  'enum.SmsAndEmail': 'SMS et e-mail',
  'enum.Sunday': 'Dimanche',
  'enum.Monday': 'Lundi',
  'enum.Tuesday': 'Mardi',
  'enum.Wednesday': 'Mercredi',
  'enum.Thursday': 'Jeudi',
  'enum.Friday': 'Vendredi',
  'enum.Saturday': 'Samedi',
  'enum.PassengerMobile': 'App passagers (mobile)',
  'enum.PassengerWeb': 'Site passagers',
  'enum.Passenger': 'Passager',
  'enum.TicketClass': 'Classe de billet',
  'enum.TariffParameter': 'Tarif',
  'enum.AllCompanies': 'Toutes les compagnies',
  'enum.CustomCompanies': 'Compagnies choisies',
  'enum.Shipment': 'Colis',
  'enum.Baggage': 'Bagage',
  'enum.Trip': 'Trajet',
  'enum.OneTime': 'Une fois',
  'enum.MultipleTimes': 'Plusieurs fois',
  'enum.NewUsers': 'Nouveaux utilisateurs',
  'enum.OldUsers': 'Utilisateurs existants',
  'enum.AllUsers': 'Tous les utilisateurs',
  'enum.CustomUsers': 'Utilisateurs choisis',
  'enum.FixedValue': 'Montant fixe',
  'enum.PercentageBase': 'Pourcentage',
  'enum.Employee': 'Employé',
  'enum.ExternalUser': 'Utilisateur externe',
  'enum.NationalIdentityCard': 'Carte nationale d\'identité',
  'enum.Passport': 'Passeport',
  'enum.Cash': 'Espèces',
  'enum.MobileMoney': 'Mobile money',
  'enum.CreditCard': 'Carte bancaire',
  'enum.Miles': 'Miles',
  'enum.Credit': 'Crédit',
  'enum.Wallet': 'Portefeuille',
  'enum.CreditNote': 'Avoir',
  'enum.Bank': 'Banque',
  'enum.PrePaid': 'Prépayé',
  'enum.PostPaid': 'Postpayé',
  'enum.First': 'Premier',
  'enum.Default': 'Par défaut',
  'enum.Paid': 'Payant',
  'enum.Extension': 'Extension',
  'enum.Receipts': 'Reçus',
  'enum.Tags': 'Étiquettes',
  'enum.Deposit': 'Dépôt',
  'enum.Withdraw': 'Retrait',
  'enum.Ready': 'Prête',
  'enum.Open': 'Ouverte',
  'enum.Closed': 'Fermée',
  'enum.International': 'International',
  'enum.National': 'National',
  'enum.Increase': 'Hausse',
  'enum.Decrease': 'Baisse',
  'enum.Percentage': 'Pourcentage',
  'enum.Merchant': 'Marchand',
  'enum.TransportCompanies': 'Compagnies de transport',
  'enum.Customer': 'Client',
  'enum.Operators': 'Opérateurs',
  'enum.Merchants': 'Marchands',
  'enum.Companies': 'Compagnies',
  'enum.Issued': 'Émis',
  'enum.CheckedIn': 'Enregistré',
  'enum.Cancelled': 'Annulé',
  'enum.Pending': 'En attente',
  'enum.Expired': 'Expiré',
  'enum.UnUsed': 'Non utilisé',
  'enum.Boarded': 'Embarqué',
  'enum.Waiting': 'En attente de place',
  'enum.Free': 'Gratuit',
  'enum.CancelRequested': 'Annulation demandée',
  'enum.Replaced': 'Remplacé',
  manageTicket_ReplacedBy: 'Remplacé par {{ref}}',
  'enum.DidNotAnswer': 'Pas de réponse',
  'enum.AskedToCallBack': 'Demande à être rappelé',
  'enum.Positive': 'Positif',
  'enum.Negative': 'Négatif',
  'enum.Moderate': 'Neutre',
  'enum.NotUsingApp': 'N\'utilise pas l\'app',
  'enum.Upload': 'Fichier',
  'enum.Youtube': 'YouTube',
  'enum.OneWay': 'Aller simple',
  'enum.Return': 'Aller-retour',
  'enum.Male': 'Homme',
  'enum.Female': 'Femme',
  salesReport_StationGroup: 'Gare de vente : {{station}} – {{count}} lignes',
  'Back Home': 'Retour à l\'accueil',
  'Export PDF': 'Exporter en PDF',
  'Export Excel': 'Exporter en Excel',
  'Toilet Right': 'Toilettes (droite)',
  'Generate seat name': 'Générer les noms des sièges',
  'Log Reconciliation': 'Enregistrer le rapprochement',
  'Only Departure trips': 'Départs seulement',
  'Only Arrival trips': 'Arrivées seulement',
  'Toggle full screen': 'Plein écran',
  'Manage Roles': 'Gérer les rôles',
};

export default frLang;
